export enum createCompanyGroupFormFields {
  name = 'name',
  contribution = 'contribution',
  maxCap = 'maxCap',
  lockupPeriod = 'lockupPeriod',
  coContributionDueDate = 'coContributionDueDate',
  numberOfWithdrawalsAllowed = 'numberOfWithdrawalsAllowed',
  externalPortfolioIds = 'externalPortfolioIds',
}
